/* eslint-disable */
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Skills from './Components/Skills/Skills';
import Services from './Components/Services/Services';
import Qualifications from './Components/Qualifications/Qualifications';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import Scrollup from './Components/Scrollup/Scrollup';
import Work from './Components/Work/Work';

import './App.css';

function App () {

  return (
    <>
    <Header />
    <main className='main'>
      <Home />
      <About />
      <Skills />
      <Services />
      <Qualifications />
      <Work />
      <Contact />
    </main>
    <Footer />
    <Scrollup />
    </>
  );
}

export default App;
